<style lang="scss" scoped>
.characteristic-title {
  height: 8.3vh;
  width: auto;
  margin-top: 1vh;
}
.banner-block {
	width: 90%;
  	height: 80vh;
  	margin-left: 5%;
	background: url('../../assets/mobile/characteristic-bg.png');
	background-size: 100% 100%;
	padding-top: 2.3vh;
  	padding-bottom: 2vh;
	.banner-item {
		width: 100%;
		height: 100%;
	}
}
.left-btn {
	position: absolute;
  	left: 0;
  	top: 56vh;
	width: 6%;
	height: auto;
}
.right-btn {
	position: absolute;
	right: 0;
	top: 56vh;
	width: 6%;
	height: auto;
}
.slide-fade-enter-active {
	transition: all 2s ease;
}
.slide-fade-enter {
  opacity: 0.3;
}
</style>

<template>
	<div class="m-characteristic mobile-common">
    	<img class="characteristic-title" src="../../assets/mobile/characteristic-title.png" alt="characteristic-title">
		<div class="banner-block">
			<template v-for="(item, index) in bannerList">
				<transition name="slide-fade" :key="item.ifId">
					<img 
						v-show="index == numberChoose" 
						class="banner-item" 
						:src="item.filePath" 
						:alt="item.fileName"
					>
				</transition>
			</template>
		</div>
		<img @click="goPreview" class="left-btn" src="../../assets/pc/left.png" alt="">
		<img @click="goNext" class="right-btn" src="../../assets/pc/right.png" alt="">
	</div>
</template>

<script>
export default {
	name:'m-characteristic',
	data() {
		return {
			bannerList: [],
			numberChoose: 0,
			timeInterval: null
		}
	},
	mounted() {
		const width = document.body.clientWidth;
		if(width > 850) {
			this.$router.push({name: 'p-characteristic'});
		} else {
			this.init();
		}
	},
	methods: {
		init() {
			this.$http.get('/api/website/getWorldFeatureInfo?platform=2').then((rsp) => {
				this.bannerList = rsp.result.worldFeature;
				this.interval();
			});
		},
		interval() {
			this.timeInterval = setInterval(() => {
				if(this.bannerList.length <= 1) {
					clearInterval(this.timeInterval);
				} else {
					if(this.numberChoose == this.bannerList.length-1) {
						this.numberChoose = 0;
					} else {
						this.numberChoose ++;
					}
				}
			}, 6000);
		},
		clearInterval() {
			clearInterval(this.timeInterval);
		},
		goPreview() {
			if(this.numberChoose == 0) {
				this.numberChoose = this.bannerList.length - 1;
			} else {
				this.numberChoose --;
			}
		},
		goNext() {
			if(this.numberChoose + 1 >= this.bannerList.length) {
				this.numberChoose = 0;
			} else {
				this.numberChoose ++;
			}
		}
	},
	beforeDestroy() {
		this.clearInterval();
	}
}
</script>